import { useRef, useEffect } from 'react';
import { Button } from '../components/Button.jsx';
import { PAGE, ROLE, ROLE_LABEL, ROLES } from '../state/pages.js';

export function RoleEntryPage({ playerRole, onRoleChange, onNavigate }) {
  const containerRef = useRef(null);

  useEffect(() => {
    containerRef.current?.focus();
  }, []);

  function handleRoleSelect(role) {
    onRoleChange(role);
  }

  function handleBack() {
    onNavigate(PAGE.SETUP_COUNTRY);
  }

  function handleStart() {
    if (playerRole) {
      onNavigate(PAGE.GAME);
    }
  }

  const isValid = playerRole && playerRole !== '';

  return (
    <main tabIndex={-1} className="onboarding-screen onboarding-role">
      <div className="onboarding-content">
        <h1 className="onboarding-title">I am a...</h1>

        <div
          className="onboarding-role-chips"
          role="group"
          aria-label="Select your role"
          ref={containerRef}
        >
          {ROLES.map((role) => (
            <button
              key={role}
              type="button"
              className={
                'onboarding-chip ' +
                (playerRole === role ? 'onboarding-chip-active' : '')
              }
              onClick={() => handleRoleSelect(role)}
              data-testid={`role-${role}`}
              data-audio-cue="buttonSecondary"
            >
              {ROLE_LABEL[role]}
            </button>
          ))}
        </div>

        <div className="onboarding-actions">
          <Button
            variant="ghost"
            onClick={handleBack}
            changesScreen
            testId="role-back"
            audioCue="buttonSecondary"
          >
            Back
          </Button>
          <Button
            onClick={handleStart}
            changesScreen
            disabled={!isValid}
            testId="role-start"
            audioCue="buttonSecondary"
          >
            Start Game
          </Button>
        </div>
      </div>
    </main>
  );
}
